export var version = '3.7.13';
//# sourceMappingURL=version.js.map